import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Skeleton } from '@mui/material';
import TitleBar from '@/components/_common/TitleBar';
import Breadcrumbs from '@/components/_common/Breadcrumbs';
import { useQuery } from '@/components/_hooks/useQuery';
import Refresh from '@/components/_common/Refresh';
import { useAppSelector } from '@/redux/hooks';
import { selectTitlesById } from '@/redux/selectors/titleV2Selectors';
import { useTitleURLParser } from '@/components/TitleDetail/v2/hooks/useTitleURLParser';
import type { TitleEntityV2 } from '@/redux/slices/titleV2Slice.types';
import { buildTitleURL } from '@/_utils/titleUtils';

interface Breadcrumb {
  label: string;
  url: string;
}

interface Props {
  onRefreshButtonClick(): void;
}

const TitleDetailTitleBarV2: React.FC<Props> = ({ onRefreshButtonClick }) => {
  const query = useQuery();
  const tab = query.get('tab') || 'metadata';
  const { path } = useTitleURLParser();
  const titlesById = useAppSelector(selectTitlesById);

  const breadcrumbs: (Breadcrumb | undefined)[] = [];

  path.forEach((titleId, index) => {
    const title: TitleEntityV2 | undefined = titlesById[titleId];

    if (title) {
      breadcrumbs.push({
        label: title.name,
        url: buildTitleURL({ path: path.slice(0, index + 1), tab })
      });
    } else {
      // title is not loaded yet
      breadcrumbs.push(undefined);
    }
  });

  // remove whatever the last breadcrumb ended up being
  // because it should not be a link
  const lastBreadcrumb = breadcrumbs.pop();

  return (
    <TitleBar style={{ marginBottom: 50 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/titles" key="titles">
            Titles
          </Link>
          {breadcrumbs.map((breadcrumb, i) =>
            breadcrumb ? (
              <Link key={i} to={breadcrumb.url}>
                {breadcrumb.label}
              </Link>
            ) : (
              <Skeleton key={i} variant="text" width={100} />
            )
          )}
          <span>{lastBreadcrumb ? <span>{lastBreadcrumb.label}</span> : <Skeleton variant="text" width={100} />}</span>
        </Breadcrumbs>
        <Refresh onClick={onRefreshButtonClick} />
      </Grid>
    </TitleBar>
  );
};

export default TitleDetailTitleBarV2;
